import React from 'react'

export interface IJsonProps {
	data: any;
	title?: string;
}

const json: React.FunctionComponent<IJsonProps> = ({ data, title }) => {
	return (
		<>
			{title &&
				<p>{title}</p>}
			<pre>
				{JSON.stringify(data, null, 4)}
			</pre>
		</>
	)
}

export default json;